function _typeof(obj) { "@babel/helpers - typeof"; if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") { _typeof = function _typeof(obj) { return typeof obj; }; } else { _typeof = function _typeof(obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }; } return _typeof(obj); }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } }

function _createClass(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties(Constructor.prototype, protoProps); if (staticProps) _defineProperties(Constructor, staticProps); return Constructor; }

function _possibleConstructorReturn(self, call) { if (call && (_typeof(call) === "object" || typeof call === "function")) { return call; } return _assertThisInitialized(self); }

function _assertThisInitialized(self) { if (self === void 0) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return self; }

function _getPrototypeOf(o) { _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf : function _getPrototypeOf(o) { return o.__proto__ || Object.getPrototypeOf(o); }; return _getPrototypeOf(o); }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function"); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, writable: true, configurable: true } }); if (superClass) _setPrototypeOf(subClass, superClass); }

function _setPrototypeOf(o, p) { _setPrototypeOf = Object.setPrototypeOf || function _setPrototypeOf(o, p) { o.__proto__ = p; return o; }; return _setPrototypeOf(o, p); }

import React, { Component } from 'react';
import ReactDOM from 'react-dom';
import styled, { css } from 'styled-components';
export var Overlay = /*#__PURE__*/function (_Component) {
  _inherits(Overlay, _Component);

  function Overlay() {
    var _this;

    _classCallCheck(this, Overlay);

    _this = _possibleConstructorReturn(this, _getPrototypeOf(Overlay).apply(this, arguments));

    _this.handleClose = function () {
      _this.props.onClose && _this.props.onClose();
    };

    _this.handleEscKey = function (e) {
      var ESC_KEY = 27;

      if (_this.props.closeOnEscKey && e.keyCode === ESC_KEY) {
        _this.handleClose();
      }
    };

    return _this;
  }

  _createClass(Overlay, [{
    key: "componentDidMount",
    value: function componentDidMount() {
      if (document) {
        document.addEventListener('keyup', this.handleEscKey);
      }
    }
  }, {
    key: "componentWillUnmount",
    value: function componentWillUnmount() {
      if (document) {
        document.removeEventListener('keyup', this.handleEscKey);
      }
    }
  }, {
    key: "render",
    value: function render() {
      if (!document) return null;
      var _this$props = this.props,
          className = _this$props.className,
          isOpen = _this$props.isOpen;
      var portalElement = document.getElementById(this.props.portalContainerId);
      var overlay = React.createElement("div", {
        className: "bbui-overlay ".concat(className),
        onClick: this.props.closeOnOverlayClick ? this.handleClose : function () {}
      }, React.createElement("div", {
        className: "bbui-overlay-container"
      }, this.props.children));
      return isOpen && portalElement && ReactDOM.createPortal(overlay, portalElement);
    }
  }]);

  return Overlay;
}(Component);
Overlay.defaultProps = {
  className: '',
  side: 'center',
  isOpen: false,
  showShadow: true,
  closeOnOverlayClick: true,
  closeOnEscKey: true,
  depth: 1
};
var centerStyles = css(["justify-content:center;align-items:center;"]);
var leftStyles = css(["align-items:flex-start;"]);
var rightStyles = css(["align-items:flex-end;"]);
var bottomStyles = css(["justify-content:flex-end;"]);
var topStyles = css(["justify-content:flex-start;"]);

var boxShadow = function boxShadow(theme, depth) {
  switch (depth) {
    case 3:
      return css(["box-shadow:0 4px 8px 4px rgba(167,167,167,0.5);"]);

    case 2:
      return css(["box-shadow:0 2px 4px 2px rgba(167,167,167,0.5);"]);

    case 1:
      return css(["box-shadow:0 1px 2px 1px rgba(167,167,167,0.5);"]);

    case 0:
    default:
      return css(["border:1px solid ", ";"], theme.colors.backgroundShades.strong);
  }
}; // Workaround for styled-components bug https://github.com/DefinitelyTyped/DefinitelyTyped/issues/31491


var StyledOverlay = styled(Overlay)(function (_ref) {
  var theme = _ref.theme,
      showShadow = _ref.showShadow,
      side = _ref.side,
      depth = _ref.depth;
  return css(["position:fixed;left:0;top:0;width:100vw;height:100vh;z-index:", ";transition:background-color .25s ease-in-out;", " display:flex;flex-direction:column;", " ", " ", " ", " ", " .bbui-overlay-container{color:", ";background-color:", ";z-index:", ";", ";}"], theme.depth.overlay, showShadow && css(["background:", ";"], theme.colors.backgroundShades.overlay), side === 'top' && topStyles, side === 'right' && rightStyles, side === 'bottom' && bottomStyles, side === 'left' && leftStyles, side === 'center' && centerStyles, theme.colors.text, theme.colors.background, theme.depth.overlay + 1, boxShadow(theme, depth));
});
StyledOverlay.defaultProps = Overlay.defaultProps;
export default StyledOverlay;